import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Resets scroll position on navigation.
 * - Plain link to a new page -> jump to the very top.
 * - Link with a #section anchor -> open that section instead.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = decodeURIComponent(hash.slice(1));
      const scrollToSelector = () => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "auto", block: "start" });
          return true;
        }
        return false;
      };
      if (scrollToSelector()) return;
      // The section may still be rendering; retry once on the next frame.
      const raf = requestAnimationFrame(() => {
        if (!scrollToSelector()) window.scrollTo({ top: 0, left: 0 });
      });
      return () => cancelAnimationFrame(raf);
    }

    window.scrollTo({ top: 0, left: 0 });
  }, [pathname, hash]);

  return null;
}
